var E=(P=>(P.POPUP="POPUP",P.REDIRECT="REDIRECT",P))(E||{});export{E as a};
